export default __webpack_public_path__ + "static/pexels-tim-mossholder-9539099-3fcb0818d0911c8e174ea12f7f5db372.jpg";